module.exports = __webpack_public_path__ + "img/rs.dc36f102.png";